
  import { css } from 'lit';
  export const styles = css`:host{--track-height: var(--ig-linear-bar-track-height, 0.125rem);--ig-theme: fluent;--ig-theme-variant: light}`;
  